export default __webpack_public_path__ + "static/media/smiley2-open.f37fb521.svg";